import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncPhosphorIconRegular = createAsyncIcon(() => import('./PhosphorIconRegular'));

export default AsyncPhosphorIconRegular;

AsyncPhosphorIconRegular.displayName = 'AsyncPhosphorIconRegular';
